import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

function animations() {
	gsap.registerPlugin(ScrollTrigger);

	const icons = document.querySelectorAll('.social-media-icon');

	if (icons) {
		icons.forEach((icon, i) => {
			gsap.from(icon, {
				y: -100,
				opacity: 0,
				duration: 1,
				ease: "bounce.out",
				delay: i * 0.2,
				scrollTrigger: {
					trigger: icon,
					start: "top 100%",
					toggleActions: "restart none none none",
				},
			});
		});
	}

	const allArrows = document.querySelectorAll('.arrows');

	if (allArrows) {
		allArrows.forEach(svg => {
			const paths = svg.querySelectorAll('path');

			gsap.killTweensOf(paths);

			const tl = gsap.timeline({repeat: -1, repeatDelay: 0.5});

			paths.forEach((path, i) => {
				tl.fromTo(path,
					{x: -20, opacity: 0},
					{x: 0, opacity: 1, duration: 0.5, ease: 'power2.out'},
					i * 0.2
				);
			});

			const lastFadeInEnd = (paths.length - 1) * 0.2 + 0.5;

			[...paths].reverse().forEach((path, i) => {
				tl.to(path,
					{x: 20, opacity: 0, duration: 0.5, ease: 'power2.in'},
					lastFadeInEnd + 0.5 + i * 0.2
				);
			});
		});
	}

	const vorteileEl = document.querySelector('.vorteile');

	if (vorteileEl) {
		const cells = vorteileEl.querySelectorAll('.status-cell');

		gsap.set(cells, {opacity: 0, scale: 0.8});

		ScrollTrigger.create({
			trigger: vorteileEl,
			start: "top 80%",
			toggleActions: "play none none reverse",
			onEnter: () => animateCells(cells),
			onLeaveBack: () => hideCells(cells),
		});
	}
}

function animateCells(cells) {
	gsap.to(cells, {
		opacity: 1,
		scale: 1,
		duration: 0.35,
		stagger: 0.15,
		ease: "power1.in",
	});
}

function hideCells(cells) {
	gsap.to(cells, {
		opacity: 0,
		scale: 0.8,
		duration: 0.05,
		stagger: 0.1,
		ease: "power1.in",
	})
}

export {animations};
